// app.js
import Vue from 'vue'

import './bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

import common from "./common";
Vue.prototype.common = common;

var app = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')


Vue.prototype.$message = (message, type, title) => {
  type = {
    i: "info",
    d: "danger",
    s: "success",
    w: "warning"
  }[type] || "primary";
  app.$bvToast.toast(message, {
    title: title || type,
    variant: type,
    solid: true
  })
}
console.log("\n %c OnePoint-front-end 200607 %c https://github.com/ukuq/onepoint", "background: #35495e; padding: 5px; border-radius: 3px 0 0 3px; color: #fff", "background: #fadfa3; padding: 5px; border-radius: 0 3px 3px 0; color: #fff");
console.log("使用中若发现问题，欢迎到 github 反馈");